import React from "react";
import "./style.scss";
import config from "./../../utils/const";

import Buttom from "../../components/Buttom";
import Title from "../../components/Title";
import LayoutDefault from "../Shared/LayoutDefault";

import { ContextDefault } from "./../../context/Provider";

const Start = () => {
  const context = React.useContext(ContextDefault);

  React.useEffect(() => {
    context.actions.setProgressBarVisiblity(false);
  }, [context.actions]);

  return (
    <div className="wrapper-start">
      <LayoutDefault
        renderButtom={() => (
          <div className="wrapper-buttons">
            <Buttom to={`${config.url}educacao/perfil`} text="Educação" />
            <Buttom to={`${config.url}esporte/perfil`} text="Esporte" />
          </div>
        )}
      >
        <p>Obrigado pelo interesse.</p>
        <Title className="title">Selecione a área que deseja apoiar.</Title>
      </LayoutDefault>
    </div>
  );
};

export default Start;
